import Allow from './Allow';

export default Allow;
